import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { savePageHistory } from '../../redux/actions/action-creator';

/**
 * A hook that works like useState but persists its value in Redux history.
 * @param {string} key - Unique key for the state within the page.
 * @param {any} initialState - Default value.
 */
export const usePageState = (key, initialState) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname;

    const savedState = useSelector(state =>
        state.common.page_history?.[path]?.state?.[key]
    );

    const [value, setValue] = useState(
        savedState !== undefined ? savedState : initialState
    );

    useEffect(() => {
        if (savedState !== undefined && savedState !== value) {
            setValue(savedState);
        }
    }, [savedState]);

    useEffect(() => {
        const syncToRedux = (dispatch, getState) => {
            const currentPageState = getState().common.page_history?.[path]?.state || {};
            if (currentPageState[key] !== value) {
                dispatch(savePageHistory(path, { ...currentPageState, [key]: value }));
            }
        };
        dispatch(syncToRedux);
    }, [value, path, key, dispatch]);

    return [value, setValue];
};

export default usePageState;
